import React, { FC } from 'react'
import ImgUtil from '../../../../utils/img.utils'
import formatInlineCode from '../../../../utils/shortTextFormatting'
import Typography from '../../typography'
import WrapperImage from '../../wrapperImage'
import { BlogPostItem } from '../style'

type Props = {
  blogSlug: string
  blogImageURL: string
  blogImageAlt: string
  blogCategoryPath: string
  convertedDate: string
  blogTitle: string
  blogSubtitle: string
  blogCategory: any
}

export const BlogPost: FC<Props> = ({
  blogSlug,
  blogImageURL,
  blogImageAlt,
  blogCategoryPath,
  convertedDate,
  blogTitle,
  blogSubtitle,
  blogCategory,
}) => {
  const image = (
    <div className="BlogPostItem-Img-Container">
      {blogImageURL && (
        <WrapperImage
          className="BlogPostItem-Img"
          src={ImgUtil.getResizedImageUrl(blogImageURL, 'width=484')}
          alt={blogImageAlt}
          width={384}
          height={216}
          threshold={650}
        />
      )}
    </div>
  )

  const categoryDate = (
    <div className="BlogPostItem-Text-Category-Date">
      {blogCategory && (
        <Typography className="BlogPostItem-Text-Category" type="captionAlt">
          {blogCategoryPath && ['ai', 'rpa'].includes(blogCategoryPath)
            ? blogCategoryPath
            : blogCategory}
        </Typography>
      )}

      {convertedDate && (
        <Typography className="BlogPostItem-Text-Date" type="caption">
          {convertedDate}
        </Typography>
      )}
    </div>
  )

  return (
    <BlogPostItem href={blogSlug}>
      {image}

      <div className="BlogPostItem-Text">
        {categoryDate}

        {blogTitle && (
          <Typography className="BlogPostItem-Title" type="header6">
            {formatInlineCode(blogTitle)}
          </Typography>
        )}

        {blogSubtitle && (
          <Typography className="BlogPostItem-Subtitle font__inter" type="bodyXS">
            {blogSubtitle}
          </Typography>
        )}
      </div>
    </BlogPostItem>
  )
}
